import type { BackLinkResolver } from './types';

export const home: BackLinkResolver = () => 'home';

export const homeLink: BackLinkResolver = (context) => (context.isMobile ? undefined : 'home');

export const goBack: BackLinkResolver = (context) => context.goBack;

export const custom =
  (link: string): BackLinkResolver =>
  () =>
    link;

export const customFn =
  (fn: () => void): BackLinkResolver =>
  () =>
    fn;

export const mobileHome: BackLinkResolver = (context) => (context.isMobile ? undefined : 'home');

export const desktopHome: BackLinkResolver = (context) => (context.isMobile ? goBack(context) : home(context));
export const fallback =
  (primary: BackLinkResolver, secondary: BackLinkResolver): BackLinkResolver =>
  (context) =>
    primary(context) || secondary(context);
